import { Link, useLocation } from "react-router-dom";
import { FileText, LayoutDashboard } from "lucide-react";
import { useAuthStore } from "../../../store/auth/auth.store";
import { ROUTES } from "../../../routes/routes";
import { RoleEnum } from "../../../api/client/types/user.types";
import clsx from "clsx";

export const Header: React.FC = () => {
  const { isAuthenticated, isPreAuthenticated, user } = useAuthStore();
  const isAdmin = user?.role === RoleEnum.ADMINISTRATOR;
  const location = useLocation();

  // Check if current path matches the route
  const isDashboardActive =
    location.pathname === ROUTES.DASHBOARD.ADMINISTRATOR;
  const isReportsActive = location.pathname === ROUTES.REPORTS;

  return (
    <header className="bg-white shadow-sm w-full">
      <div className="mx-auto flex max-w-full flex-col sm:flex-row sm:items-center sm:justify-between px-4 py-3 gap-3 sm:gap-0">
        {/* Left section: logo + title */}
        <div className="flex items-center justify-center sm:justify-start gap-2">
          <img
            src="/logo.jpeg"
            alt="Salvavidas Colombia"
            className="w-10 h-10 sm:w-12 sm:h-12 object-cover rounded-md"
          />
          <span className="text-lg sm:text-xl font-semibold text-lifeguards-blue leading-tight uppercase">
            Salvavidas Colombia
          </span>
        </div>

        {/* Right section: navigation links (visible only when logged in) */}
        {(isAuthenticated || isPreAuthenticated) && (
          <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-end gap-3 w-full sm:w-auto">
            {/* Dashboard link (only for admin) */}
            {isAdmin && (
              <Link
                to={ROUTES.DASHBOARD.ADMINISTRATOR}
                className={clsx(
                  "flex items-center gap-2 font-medium text-sm sm:text-base transition-colors w-full sm:w-auto justify-center sm:justify-start px-3 py-2 rounded-md",
                  isDashboardActive
                    ? "text-white bg-lifeguards-blue"
                    : "text-lifeguards-blue hover:text-lifeguards-light-blue hover:bg-gray-50"
                )}
              >
                <LayoutDashboard size={18} />
                Dashboard
              </Link>
            )}
            {/* Reports link (only for admin) */}
            {isAdmin && (
              <Link
                to={ROUTES.REPORTS}
                className={clsx(
                  "flex items-center gap-2 font-medium text-sm sm:text-base transition-colors w-full sm:w-auto justify-center sm:justify-start px-3 py-2 rounded-md",
                  isReportsActive
                    ? "text-white bg-lifeguards-blue"
                    : "text-lifeguards-blue hover:text-lifeguards-light-blue hover:bg-gray-50"
                )}
              >
                <FileText size={18} />
                Reportes
              </Link>
            )}
          </div>
        )}
      </div>
    </header>
  );
};
